export const MAPPED_PATTERNS: Record<PatternType, { key: PatternType; name: string }> = {
  CROISILLON: { name: "Croisillon", key: "CROISILLON" },
  CHENILLARD: { name: "Chenillard", key: "CHENILLARD" },
  DASH: { name: "Tiret", key: "DASH" },
  POINT: { name: "Point", key: "POINT" },
  CUSTOM: { name: "Personnalisable", key: "CUSTOM" },
};

export const PATTERNS_MAPPED_BY_NAME: Dic<{ name: string; key: PatternType }> = Object.values(MAPPED_PATTERNS).reduce(
  (curr, next) => ({ ...curr, [next.name]: { ...next } }),
  {}
);

export const PATTERNS = Object.values(MAPPED_PATTERNS);
